/**
 * モーダル表示
 *
 * Author : T.Tomida <t-tomida@shinwatec.net>
 * Company : Shinwatec Inc.
 * Copyright : Copyright(c) 2018 Shinwatec Inc.
 * Create : 2018.02
 * module : jquery
 */

export default class{
  constructor(params){
    this.settings = Object.assign({},this.defaults(),params);
  }

  defaults(){
    return{
      target : 'body',
      modalId : 'modal',
      el : '',
      activeClass : 'active',
      contentSelector : '#container',
      overlayClose: true,
    }
  }

  setHtml(html){
    this.settings.el = html;
    return this
  }

  show(){
    this.settings.scrPos = $( window ).scrollTop();
    const baseDom = this.createHtml();
    this.settings.createDom = baseDom;
    if('func' in this.settings){
      this.settings.func(baseDom)
    }
    $('#'+this.settings.modalId).remove();
    $(this.settings.target).append(baseDom);
    setTimeout(()=>{
      baseDom.addClass(this.settings.activeClass);
    },100);

    baseDom.find('.modal-close').on('click',()=>{
      this.close();
    })
    if(this.settings.overlayClose){
      baseDom.find('.modal-overlay').on('click',() => {
        this.close();
      })
    }
    /*
    $(this.settings.contentSelector).css({
      position : 'fixed',
      width : '100%',
      top: -1 * this.settings.scrPos,
    });
    */
  }

  close(){
    $(this.settings.contentSelector).removeAttr("style");
    $('html, body').prop({scrollTop: this.settings.scrPos});
    this.settings.createDom.removeClass(this.settings.activeClass);
  }

  createHtml(){
    const baseHtml = '<div id="'+this.settings.modalId+'"><div class="modal-overlay"></div><div class="modal-content-wrap"><div class="modal-content">'+this.settings.el+'</div><div class="modal-close"></div></div></div>';
    const baseDom = $(baseHtml);
    return baseDom;
  }
  setEvent(func){
    this.settings.func = func
    return this
  }
}
